import { ReduxThunk } from '../../types/thunk';
import { fetchExchangeRates } from '../../api/exchangeRates';

export const getExchangeRates = (): ReduxThunk => async (
  dispatch,
  getState
) => {
  const rates = await fetchExchangeRates();
  console.log(rates);
  if (!rates) return;
  dispatch({ type: 'EXCHANGE_RATES', exchangeRates: rates });
};
